export const ngieGroups = {
  rexpLoanRelationshipAmounts: "rexpLoanRelationshipAmounts",
  rexpDerivativeContractAmounts: "rexpDerivativeContractAmounts",
  rexpFinanceLeasesAndOtherFinancingArrangements:
    "rexpFinanceLeasesAndOtherFinancingArrangements",
  rexpOtherRelevantExpenseAmounts: "rexpOtherRelevantExpenseAmounts",

  rincLoanRelationshipAmounts: "rincLoanRelationshipAmounts",
  rincDerivativeContractAmounts: "rincDerivativeContractAmounts",
  rincFinanceLeasesAndOtherFinancingArrangements:
    "rincFinanceLeasesAndOtherFinancingArrangements",
  rincOtherRelevantIncomeAmounts: "rincOtherRelevantIncomeAmounts",

  oadjAutomaticApplication: "oadjAutomaticApplication",
  oadjAdjustmentsForInterestAllowanceConsolidated:
    "oadjAdjustmentsForInterestAllowanceConsolidated",
  oadjAdjustmentsForInterestAllowanceNonConsolidated:
    "oadjAdjustmentsForInterestAllowanceNonConsolidated",
  oadjAdjustmentsForInterestAllowanceAlternativeCalculation:
    "oadjAdjustmentsForInterestAllowanceAlternativeCalculation",
  oadjOther: "oadjOther",
};

export function getNgieRowConfig(tooltips = {}) {
  return {
    //#region Relevant expense amounts recognised in group's P&L (s.411) (enter as positive numbers)
    // Loan Relationship Amounts
    loan_relationship_interest_payable: {
      label: "Interest payable under a loan relationship - s411(1)(a)",
      type: "positive",
      notes: tooltips.loan_relationship_interest_payable,
      group: ngieGroups.rexpLoanRelationshipAmounts,
    },
    loan_relationship_ancillary_expenses: {
      label:
        "Expenses ancillary to a loan relationship or related transaction (including bank charges) - 411(1)(b)",
      type: "positive",
      notes: tooltips.loan_relationship_ancillary_expenses,
      group: ngieGroups.rexpLoanRelationshipAmounts,
    },
    loan_relationship_losses: {
      label:
        "Losses arising from a loan relationship/related transaction (excluding exchange losses and impairment losses) - 411(1)(c)",
      type: "positive",
      notes: tooltips.loan_relationship_losses,
      group: ngieGroups.rexpLoanRelationshipAmounts,
    },
    interest_relevant_non_lending_relationships: {
      label:
        "Interest payable or, for periods of account beginning on or after 1 April 2023, all debits (excluding exchange losses and impairment losses) under relevant non-lending relationships - s411(1)(j)",
      type: "positive",
      notes: tooltips.interest_relevant_non_lending_relationships,
      group: ngieGroups.rexpLoanRelationshipAmounts,
    },
    // Derivative Contract Amounts
    derivatives_losses: {
      label:
        "Losses arising from a relevant derivative contract or a related transaction (Excluding exchange losses, impairment losses, and all losses on certain “trading” derivatives – s411(1)(e)",
      type: "positive",
      notes: tooltips.derivatives_losses,
      group: ngieGroups.rexpDerivativeContractAmounts,
    },
    derivatives_ancillary_losses: {
      label:
        "Expenses ancillary to a relevant derivative or related transaction - s411(1)(f)",
      type: "positive",
      notes: tooltips.derivatives_ancillary_losses,
      group: ngieGroups.rexpDerivativeContractAmounts,
    },
    // Finance Leases and Other Financing Arrangements
    finance_charges_finance_lease: {
      label:
        "Financing charges implicit in payments made under a finance lease - s411(1)(g)",
      type: "positive",
      notes: tooltips.finance_charges_finance_lease,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_charges_debt_factoring: {
      label:
        "Financing charges related to debt factoring or any similar transaction - s411(1)(h)",
      type: "positive",
      notes: tooltips.finance_charges_debt_factoring,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_charges_service_concession: {
      label:
        "Financing charges implicit in payments made under a service concession arrangement if and to the extent that the arrangement is accounted for as a financial liability - s411(1)(i)",
      type: "positive",
      notes: tooltips.finance_charges_service_concession,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    alternative_finance_return_payable: {
      label:
        "Alternative finance return payable under alternative finance arrangements - s411(1)(k)",
      type: "positive",
      notes: tooltips.alternative_finance_return_payable,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    interest_payable_manufactured: {
      label: "Manufactured interest payable - s411(1)(l)",
      type: "positive",
      notes: tooltips.interest_payable_manufactured,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    financing_charges_debtor_repo: {
      label:
        "Financing charges in respect of the advance under a debtor repo or debtor quasi-repo - s411(1)(m)",
      type: "positive",
      notes: tooltips.financing_charges_debtor_repo,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    financing_charges_interest_payable: {
      label:
        "Financing charges treated as interest payable under a loan relationship under the finance arrangements rules (Chapter 2 of Part 16 of CTA 2010), or would be so treated if the company were within the charge to corporation tax - s411(1)(n)",
      type: "positive",
      notes: tooltips.financing_charges_interest_payable,
      group: ngieGroups.rexpFinanceLeasesAndOtherFinancingArrangements,
    },
    // Other Relevant Expense Amounts
    preference_shares_payable_dividends: {
      label:
        "Dividends payable on preference shares accounted for as a financial liability - s411(1)(d)",
      type: "positive",
      notes: tooltips.preference_shares_payable_dividends,
      group: ngieGroups.rexpOtherRelevantExpenseAmounts,
    },
    depreciation_relevant_expense: {
      label:
        "Capitalised expense amounts brought into account in financial statements of the group in determining the carrying value of a non-relevant asset, where the carrying value of that asset is written down - s410(3)",
      type: "positive",
      notes: tooltips.depreciation_relevant_expense,
      group: ngieGroups.rexpOtherRelevantExpenseAmounts,
    },
    //#endregion

    //#region Relevant income amounts recognised in group's P&L (s.411) (enter as negative numbers)
    // Loan Relationship Amounts
    loan_relationship_interest_receivable: {
      label: "Interest receivable under loan relationships",
      type: "negative",
      notes: tooltips.loan_relationship_interest_receivable,
      group: ngieGroups.rincLoanRelationshipAmounts,
    },
    loan_relationship_profits: {
      label:
        "Profits arising from a loan relationship or a related transaction (excluding exchange gains and the reversal of impairment losses) - s411(2)(b)",
      type: "negative",
      notes: tooltips.loan_relationship_profits,
      group: ngieGroups.rincLoanRelationshipAmounts,
    },
    interest_receivable_non_lending_relationships: {
      label:
        "Interest receivable or, for periods of account beginning on or after 1 April 2023, all credits (excluding exchange gains and reversals of impairment losses) arising in respect of relevant non-lending relationships - s411(2)(h)",
      type: "negative",
      notes: tooltips.interest_receivable_non_lending_relationships,
      group: ngieGroups.rincLoanRelationshipAmounts,
    },
    // Derivative Contract Amounts
    derivatives_gains: {
      label:
        "Gains arising from a relevant derivative contract or a related transaction (Excluding exchange gains, the reversal of impairment losses, and all gains on certain “trading” derivatives – s411(2)(d)",
      type: "negative",
      notes: tooltips.derivatives_gains,
      group: ngieGroups.rincDerivativeContractAmounts,
    },
    // Finance Leases and Other Financing Arrangements
    finance_income_finance_lease: {
      label:
        "Financing income implicit in amounts received under a finance lease - s411(2)(e)",
      type: "negative",
      notes: tooltips.finance_income_finance_lease,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_income_debt_factoring: {
      label:
        "Financing income relating to debt factoring or any similar transaction - s411(2)(f)",
      type: "negative",
      notes: tooltips.finance_income_debt_factoring,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_income_service_concession: {
      label:
        "Financing income implicit in amounts received under a service concession arrangement if and to the extent that the arrangement is accounted for as a financial asset - s411(2)(g)",
      type: "negative",
      notes: tooltips.finance_income_service_concession,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_receivable_alternative_finance_arrangement: {
      label:
        "Alternative finance return receivable under alternative finance arrangements - s411(2)(i)",
      type: "negative",
      notes: tooltips.finance_receivable_alternative_finance_arrangement,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    interest_receivable_manufactured: {
      label: "Manufactured interest receivable - s411(2)(j)",
      type: "negative",
      notes: tooltips.interest_receivable_manufactured,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_income_debtor_repo: {
      label:
        "Financing income in respect of the advance under a creditor repo or creditor quasi-repo - s411(2)(k)",
      type: "negative",
      notes: tooltips.finance_income_debtor_repo,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    finance_income_interest_receivable: {
      label:
        "Financing income treated as interest receivable under a loan relationship under the finance arrangements rules (Chapter 2 of Part 16 of CTA 2010), or would be so treated if the company were within the charge to corporation tax - s411(2)(l)",
      type: "negative",
      notes: tooltips.finance_income_interest_receivable,
      group: ngieGroups.rincFinanceLeasesAndOtherFinancingArrangements,
    },
    // Other Relevant Income Ammounts
    preference_shares_dividends_receivable: {
      label:
        "Dividends receivable in respect of preference shares accounted for as a financial asset - s411(2)(c)",
      type: "negative",
      notes: tooltips.preference_shares_dividends_receivable,
      group: ngieGroups.rincOtherRelevantIncomeAmounts,
    },
    depreciation_relevant_income: {
      label:
        "Capitalised income amounts brought into account in financial statements of the group in determining the carrying value of a non-relevant asset, where the carrying value of that asset is written down - s410(5)",
      type: "negative",
      notes: tooltips.depreciation_relevant_income,
      group: ngieGroups.rincOtherRelevantIncomeAmounts,
    },
    //#endregion

    //#region Other adjustments required to calculate NGIE
    // Other Adjustments Required to Calculate NGIE
    adjustments_eliminate_derivatives: {
      label:
        "Adjustment to eliminate amounts included above in respect of derivatives subject to fair value accounting to which Regulation 7, 8 or 9 of the Disregard Regulations would apply - s420(3)",
      type: null,
      notes: tooltips.adjustments_eliminate_derivatives,
      group: ngieGroups.oadjAutomaticApplication,
    },
    adjustments_include_replacement_derivatives: {
      label:
        'Adjustment to include replacement "Group-Interest" derivative contract amounts for derivatives subject to fair value accounting to which Regulation 7, 8 or 9 of the Disregard Regulations would apply - s420(6)',
      type: null,
      notes: tooltips.adjustments_include_replacement_derivatives,
      group: ngieGroups.oadjAutomaticApplication,
    },
    // Adjusments for the Interest Allowance (Non-Consolidated Investment) Election
    adjustments_exclude_relevant_income: {
      label:
        "Adjustment to exclude relevant income amounts relating to financial liabilities owed by any member of an associated worldwide group headed by a company specified in the election - s427(3)(a)",
      type: "positive",
      notes: tooltips.adjustments_exclude_relevant_income,
      group: ngieGroups.oadjAdjustmentsForInterestAllowanceNonConsolidated,
    },
    // Adjustments for the Interest Allowance (Consolidated Partnership) Election
    excludePartnershipIncomeAdjustment: {
      label:
        "Adjustment to exclude relevant income and expense amounts in respect of a consolidated partnership to the extent that they are included above - s430(2)(a)",
      type: null,
      notes: tooltips.excludePartnershipIncomeAdjustment,
      group: ngieGroups.oadjAdjustmentsForInterestAllowanceConsolidated,
    },
    // Adjustments in respect of the interest allowance (alternative calculation) election (s423-426)
    taxAdjPBT: {
      label:
        "Adjustment to PBT in respect of changes in accounting policy to align with the tax treatment that would arise for interest items assuming the group was within the charge to corporation tax - s426(2)",
      type: null,
      notes: tooltips.taxAdjPBT,
      group:
        ngieGroups.oadjAdjustmentsForInterestAllowanceAlternativeCalculation,
    },
    // Other
    adjustments_specialist_regimes: {
      label: "Other adjustments required as a result of specialist regimes",
      type: null,
      notes: tooltips.adjustments_specialist_regimes,
      group: ngieGroups.oadjOther,
    },
    adjustments_other: {
      label: "Other adjustments for which there is no space above",
      type: null,
      notes: tooltips.adjustments_other,
      group: ngieGroups.oadjOther,
    },
  };
}
